import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TopicMaterialService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getTopicMaterials(topicId: number) {
    return this.http.get(
      `${this.baseUrl}/v1/topics/${topicId}/materials`
    );
  }

  createTopicMaterial(
    topicId: number,
    payload: {
      title: string;
      description?: string;
      materialType: string;
      publish: boolean;
      mediaAssetIds: number[];
      requestProcessing: boolean;
    }
  ) {
    return this.http.post(
      `${this.baseUrl}/v1/topics/${topicId}/materials`,
      payload
    );
  }

  deleteTopicMaterial(topicId: number, materialId: number) {
    return this.http.delete(
      `${this.baseUrl}/v1/topics/${topicId}/materials/${materialId}`
    );
  }

  getMaterialById(materialId: number) {
    return this.http.get(
      `${this.baseUrl}/v1/materials/${materialId}`
    );
  }

  getAllMaterials(page = 0, size = 20) {
    return this.http.get(
      `${this.baseUrl}/v1/materials?page=${page}&size=${size}`
    );
  }
}